/* Stellanuit – effets discrets : apparition au défilement, étincelles au clic, ciel étoilé */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const REVEAL = '.text-block, .icon-block, .media-block, .product-card, accordion-custom, a.button, a.button-secondary, a.button-custom';
  const BUTTONS = 'a.button, a.button-secondary, a.button-custom, .add-to-cart-button';

  // Bandeaux sombres : on y ajoute des étoiles
  const isDark = (el) => {
    const m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
    if (!m) return false;
    const [r, g, b, a = 1] = m.map(Number);
    return a > 0.5 && 0.2126 * r + 0.7152 * g + 0.0722 * b < 60;
  };
  const decorate = () => document.querySelectorAll('.section-background').forEach((el) => {
    if (isDark(el)) el.classList.add('sn-sky');
  });

  // Apparition au défilement : seulement ce qui est sous l'écran au chargement
  const reveal = () => {
    if (reduce || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('sn-in');
      io.unobserve(e.target);
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    document.querySelectorAll('main .shopify-section').forEach((section) => {
      if (section.querySelector('product-component, media-gallery, product-form-component')) return; // zone d'achat jamais cachée
      let i = 0;
      section.querySelectorAll(REVEAL).forEach((el) => {
        if (el.closest('.sn-reveal') || el.getBoundingClientRect().top < window.innerHeight) return;
        el.classList.add('sn-reveal');
        el.style.setProperty('--sn-delay', `${Math.min(i++, 5) * 80}ms`);
        io.observe(el);
      });
    });
    document.documentElement.classList.add('sn-fx');
  };

  // Étincelles champagne au clic sur un bouton
  const sparkle = (x, y) => {
    for (let k = 0; k < 8; k++) {
      const s = document.createElement('span');
      const angle = (Math.PI * 2 * k) / 8 + Math.random() * 0.5;
      const dist = 24 + Math.random() * 22;
      const size = 6 + Math.random() * 6;
      s.className = 'sn-spark';
      s.style.cssText = `left:${x}px;top:${y}px;width:${size}px;height:${size}px;--dx:${Math.cos(angle) * dist}px;--dy:${Math.sin(angle) * dist}px`;
      s.addEventListener('animationend', () => s.remove());
      document.body.appendChild(s);
    }
  };
  document.addEventListener('pointerdown', (e) => {
    const b = e.target.closest(BUTTONS);
    if (b && !reduce) sparkle(e.clientX, e.clientY);
  }, { passive: true });

  const init = () => { decorate(); reveal(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
